import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';

@Component({
    selector: 'rwidget-voucher-tickets',
    templateUrl: './voucher-tickets.component.html',
    styleUrls: ['./voucher-tickets.component.scss']
})
export class VoucherTicketsComponent implements OnInit {
    vouchers$: Observable<any[]>;
    relatedCards$: Observable<any[]>; // this is for getting to know if voucher row is odd or even

    @Output() onVoucherSelected = new EventEmitter();

    locale = this.translate.currentLang;
    constructor(private translate: TranslateService) {}

    ngOnInit() {
    }
    voucherSelected(voucher) {
        this.onVoucherSelected.emit(voucher);
    }
}
